import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ActiveStepState {
  step: number;
  setStep: (step: number) => void;
  partOneOne: boolean;
  setPartOneOne: (partOneOne: boolean) => void;
  partOneTwo: boolean;
  setPartOneTwo: (partOneTwo: boolean) => void;
  partThreeOne: boolean;
  setPartThreeOne: (partThreeOne: boolean) => void;
  partThreeTwo: boolean;
  setPartThreeTwo: (partThreeTwo: boolean) => void;
}

export const ActiveStepStore = create<ActiveStepState>()(
  persist(
    (set) => ({
      step: 1,
      setStep: (newStep: number) => set({ step: newStep }),
      partOneOne: false, // Not persisted
      setPartOneOne: (newPartOneOne: boolean) =>
        set({ partOneOne: newPartOneOne }),
      partOneTwo: false, // Not persisted
      setPartOneTwo: (newPartOneTwo: boolean) =>
        set({ partOneTwo: newPartOneTwo }),
      partThreeOne: false, // Not persisted
      setPartThreeOne: (newPartThreeOne: boolean) =>
        set({ partThreeOne: newPartThreeOne }),
      partThreeTwo: false, // Not persisted
      setPartThreeTwo: (newPartThreeTwo: boolean) =>
        set({ partThreeTwo: newPartThreeTwo }),
    }),
    {
      name: "activeStep",
      getStorage: () => localStorage,
      partialize: (state) => ({
        step: state.step,
        partOneOne: state.partOneOne,
        partOneTwo: state.partOneTwo,
        partThreeOne: state.partThreeOne,
        partThreeTwo: state.partThreeTwo,
      }),
    },
  ),
);
